import type { PropsWithChildren, ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { ACCIDENTAL_ACTION_DEBOUNCE_TIME } from "app/pages/sales-intelligence/constants/timeouts";
import { StyledAdNetworksTooltipTableView } from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/SignalsAdNetworksTooltip/styles";
import AdNetworkSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/AdNetworkSignalSubType";

import type SignalsTooltipViewModel from "../../../models/view/signals-tooltip/SignalsTooltipViewModel";
import SignalsTooltipButtonLink from "../shared/SignalsTooltipButtonLink/SignalsTooltipButtonLink";
import SignalsTooltipContent from "../shared/SignalsTooltipContent/SignalsTooltipContent";
import { StyledMoreItemsText } from "../shared/styles";
import SignalsTooltip from "../SignalsTooltip/SignalsTooltip";

type Props = PropsWithChildren<{
    signalSubType: AdNetworkSignalSubType;
    redirectLink: URL["href"];
    createViewModel(itemsLimit: number): SignalsTooltipViewModel;
    onViewAll(): void;
}>;

const SignalsAdNetworksTooltip = (props: Props) => {
    const { children, signalSubType, redirectLink, createViewModel, onViewAll } = props;

    const isAddedAdNetworks = signalSubType === AdNetworkSignalSubType.AddedAdNetworks;

    const renderOverLimitView = (props: { items: SignalsTooltipViewModel["otherItems"] }): ReactElement => {
        const { items } = props;

        return (
            <StyledMoreItemsText>
                {translate("si.signals.table-columns.tooltip.text.more", {
                    count: items.length,
                })}
            </StyledMoreItemsText>
        );
    };

    return (
        <SignalsTooltip
            debounce={ACCIDENTAL_ACTION_DEBOUNCE_TIME}
            maxWidth={450}
            content={
                <SignalsTooltipContent
                    title={translate(`si.signals.table-columns.tooltip.title.${signalSubType}`)}
                    footer={
                        <SignalsTooltipButtonLink
                            text={translate("si.signals.table-columns.tooltip.view-all.ad-networks")}
                            redirectLink={redirectLink}
                            onClick={onViewAll}
                        />
                    }
                >
                    <StyledAdNetworksTooltipTableView
                        className={isAddedAdNetworks ? "wide-tooltip-table" : undefined}
                        createViewModel={createViewModel}
                        renderOverLimitView={renderOverLimitView}
                    />
                </SignalsTooltipContent>
            }
        >
            {children}
        </SignalsTooltip>
    );
};

export default SignalsAdNetworksTooltip;
